/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-underscore-dangle */

'use-strict';

import { ILocationService, IScope, route } from 'angular';
import { SalesAPIService } from '../../shared/api/sales-api.service';
import { ConfigService } from '../../shared/config/config.service';
import { NumberConversionService } from '../../shared/converter/number-converter.service';
import { InterfaceService } from '../../shared/interface/interface.service';
import { DateService } from '../../shared/misc/date.service';
import { DeepPartial } from '../../src/app/@shared-types';
import { AutoboardVehicle } from '../../src/app/@shared-types/vehicle';
import LogService from '../../src/app/shared/services/log';
import { ToastService, ToastType } from '../../ui-components/toast/toast.service';

interface ReactivationScope extends IScope {
  vehicle: AutoboardVehicle | null,
  newVehicleData: {
    state: string,
    location: string,
    countOwner: number,
    previousOwner: string,
    deliveryDate: string | null,
  },
  reactivateVehicle: () => void,
  locations: { [key: string]: string },
  states: { [key: string]: string },
}

/* @ngInject */
export default function SalesReactivationController(
  $scope: ReactivationScope,
  toastService: ToastService,
  $location: ILocationService,
  $routeParams: route.IRouteParamsService,
  salesApiService: SalesAPIService,
  interfaceService: InterfaceService,
  dateService: DateService,
  logService: LogService,
  numberConversionService: NumberConversionService,
  configService: ConfigService,
): void {
  $scope.vehicle = null;

  $scope.locations = configService.get('general_locations') || {};
  $scope.states = configService.get('sales_car_types') || {};

  $scope.reactivateVehicle = () => {
    if (!$scope.vehicle) return;

    const data = $scope.newVehicleData;
    const updateData: DeepPartial<AutoboardVehicle> = {
      vehicleData: {
        inventory: {
          deliveryDate: numberConversionService.frontendStringToDate(data.deliveryDate),
          location: data.location,
          locationDescription: $scope.locations[data.location],
        },
        previousOwner: {
          countOwner: data.countOwner,
          previousOwner: data.previousOwner,
        },
        availability: {
          state: data.state,
          stateDescription: $scope.states[data.state],
        },
      },
    };

    salesApiService.postReactivateVehicle(String($scope.vehicle._id), updateData)
      .then(() => {
        toastService.toast(ToastType.SUCCESS, 'Fahrzeug wurde wieder in den Bestand überführt.');
        $location.url(`/vehicles/stock?id=${String($scope.vehicle!._id)}`);
      })
      .catch((e) => logService.error(e));
  };

  const init = (): void => {
    const { vehicleId } = $routeParams;
    if (!vehicleId) {
      toastService.toast(ToastType.ERROR, 'Es wird eine Fahrzeug ID benötigt.');
      return;
    }

    salesApiService.getVehicle(vehicleId)
      .then((vehicle) => {
        $scope.vehicle = vehicle;

        $scope.newVehicleData = {
          state: '',
          countOwner: vehicle.vehicleData.previousOwner?.countOwner || 0,
          location: '',
          previousOwner: vehicle.vehicleData.availability.sellData?.customer || '',
          deliveryDate: null,
        };
        $scope.newVehicleData.countOwner += 1;

        interfaceService.applyScope($scope);
      })
      .catch((e) => logService.error(e));
  };

  init();
}
